import React from "react";
import styled from "@emotion/styled";

interface LinkButtonProps {
    text: string;
    href: string;
}

const LinkButtonStyled = styled.a({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#669933",
    padding: "8px 16px",
    color: "white",
    fontSize: "16px",
    borderRadius: "25vh",
    transition: "background-color 150ms linear",
    [`:hover`]: {
        backgroundColor: "#76b23a",
    }
})

function LinkButton(props: LinkButtonProps) {

    const { text, href } = props;

    return (
        <LinkButtonStyled href={href} target="_blank">
            {text}
        </LinkButtonStyled>
    );
}

export default LinkButton;